import styled from 'styled-components';

export const ControlPanelWrapper = styled.section`
  grid-column: 1;
	width: 100%;
  height: 100vh;
`;